import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import { Dashboard } from '@components/common'
import type { EmptyStateProps } from '@fourthwall/components'
import { HeadContent } from '@fourthwall/components'

import { InfiniteScrollLoader } from '../../../../components/InfiniteScrollLoader/InfiniteScrollLoader'
import { PromotionCodesData } from '../../components/PromotionCodesData/PromotionCodesData'
import { usePromotionCodesInfinite } from '../../hooks/usePromotionCodesInfinite'

type PromotionCodesDesktopProps = {
  emptyStateProps: EmptyStateProps
}

export const PromotionCodesInfinite = ({ emptyStateProps }: PromotionCodesDesktopProps) => {
  const infiniteProps = usePromotionCodesInfinite()

  return (
    <>
      <HeadContent title="Promo codes" />
      <Dashboard.Section.Item>
        <InfiniteScroll
          dataLength={infiniteProps.data?.length || 0}
          next={infiniteProps.onLoadMore}
          hasMore={infiniteProps.hasNextPage}
          loader={<InfiniteScrollLoader />}
          scrollableTarget="scrollableDiv"
          style={{ overflow: 'none' }}
        >
          <PromotionCodesData
            // @ts-ignore extra empty interface Shop & Memberships are present can't seem to find a solution here
            data={infiniteProps.data || []}
            isLoading={infiniteProps.isLoading}
            emptyStateProps={emptyStateProps}
          />
        </InfiniteScroll>
      </Dashboard.Section.Item>
    </>
  )
}
